var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Qtxzcx),
      expression: "Qtxzcx"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种出险")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "2%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("唯一识别码 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入唯一识别码"
    },
    model: {
      value: (_vm.condition.unique_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "unique_id", $$v)
      },
      expression: "condition.unique_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("名称/品牌 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入名称/品牌"
    },
    model: {
      value: (_vm.condition.brand),
      callback: function($$v) {
        _vm.$set(_vm.condition, "brand", $$v)
      },
      expression: "condition.brand"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("保单号 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请输入保单号"
    },
    model: {
      value: (_vm.condition.policyNo),
      callback: function($$v) {
        _vm.$set(_vm.condition, "policyNo", $$v)
      },
      expression: "condition.policyNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("出险时间 ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.condition.danger_time),
      callback: function($$v) {
        _vm.$set(_vm.condition, "danger_time", $$v)
      },
      expression: "condition.danger_time"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("审批状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.approval_status),
      callback: function($$v) {
        _vm.$set(_vm.condition, "approval_status", $$v)
      },
      expression: "condition.approval_status"
    }
  }, _vm._l((_vm.spztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("出险状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "160px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.state),
      callback: function($$v) {
        _vm.$set(_vm.condition, "state", $$v)
      },
      expression: "condition.state"
    }
  }, _vm._l((_vm.cxztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px",
      "margin-left": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("导入")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Del()
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "height": "540px"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "所属项目"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unique_id",
      "align": "center",
      "label": "唯一识别码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brand",
      "align": "center",
      "label": "名称/品牌"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "model",
      "align": "center",
      "label": "规格/型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "danger_time",
      "align": "center",
      "label": "出险时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report_no",
      "align": "center",
      "label": "报案号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "policyNo",
      "align": "center",
      "label": "保单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlement_status",
      "align": "center",
      "label": "理赔情况"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.settlement_status == '0'),
            expression: "scope.row.settlement_status == '0'"
          }]
        }, [_vm._v("未理赔")]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.settlement_status == '1'),
            expression: "scope.row.settlement_status == '1'"
          }]
        }, [_vm._v("已理赔")]), _vm._v(" "), _c('p', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.settlement_status == ''),
            expression: "scope.row.settlement_status == ''"
          }]
        }, [_vm._v("已撤案")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "close_date",
      "align": "center",
      "label": "结案日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approval_status",
      "align": "center",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.approval_status === '0'),
            expression: "scope.row.approval_status === '0'"
          }],
          attrs: {
            "src": require("../../../assets/待审批.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.approval_status === '1'),
            expression: "scope.row.approval_status === '1'"
          }],
          attrs: {
            "src": require("../../../assets/已同意.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "state",
      "align": "center",
      "label": "出险状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state === '0'),
            expression: "scope.row.state === '0'"
          }],
          attrs: {
            "src": require("../../../assets/未出险.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.state === '1'),
            expression: "scope.row.state === '1'"
          }],
          attrs: {
            "src": require("../../../assets/已出险.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/详情.png")
          },
          on: {
            "click": function($event) {
              return _vm.xiangqing(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.bianji(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]), _vm._v(" "), _c('add', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showadd),
      expression: "showadd"
    }],
    ref: "adds"
  }), _vm._v(" "), _c('edit', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showedit),
      expression: "showedit"
    }],
    ref: "edits"
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571b3d48","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzCx/Qtxzcx.vue
// module id = null
// module chunks = 